import React from 'react';
import { ClickOutside, ContextMenuIcon } from 'wix-rich-content-ui-components';
import { s as styles } from '../audio.rtlignore-20182d5f.js';
import DropdownMenu from './DropdownMenu.js';
import '../style-inject.es-e7b07dd7.js';
import 'wix-rich-content-editor-common';

const ContextMenu = ({
  onClickOutside,
  contextMenuData,
  playBackMenuData,
  showContextMenu,
  showPlaybackMenu,
  onClick
}) => {
  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      onClick();
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ClickOutside, { onClickOutside }, showContextMenu && /* @__PURE__ */ React.createElement(DropdownMenu, { options: contextMenuData, onClose: onClickOutside }), showPlaybackMenu && /* @__PURE__ */ React.createElement(DropdownMenu, { options: playBackMenuData, onClose: onClickOutside })), /* @__PURE__ */ React.createElement(
    ContextMenuIcon,
    {
      "data-hook": "audioContextMenu",
      tabIndex: 0,
      onKeyPress,
      className: styles.audio_contextMenuIcon,
      onClick,
      "aria-label": "context menu"
    }
  ));
};

export { ContextMenu as default };
//# sourceMappingURL=ContextMenu.js.map
